import {ChangeDetectionStrategy, Component, HostBinding, inject, input, OnInit} from '@angular/core';
import {StoryblokStylingService} from '@core/services/storyblok-styling.service';
import {StoryblokDirective} from '@core/directives/storyblok.directive';

import {DynamicModule} from 'ng-dynamic-component';
import {NgComponentOutlet} from '@angular/common';
import {StoryblokComponentService} from '@core/services/storyblok-component.service';
import {StoryblokReadMoreComponent} from '@modules/storyblok/components/storyblok-read-more.component';
import {ReadMoreComponent} from '@layout/components/general/read-more/read-more.component';

@Component({
  selector: 'app-row',
  templateUrl: './storyblok-row.component.html',
  styleUrls: ['./storyblok-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StoryblokDirective, DynamicModule, NgComponentOutlet, ReadMoreComponent]
})

export class StoryblokRowComponent extends StoryblokReadMoreComponent implements OnInit {
  protected storyblokComponentService = inject(StoryblokComponentService);
  private storyblokStylingService = inject(StoryblokStylingService);


  readonly columns = input<any[]>();
  readonly _editable = input<any>();
  readonly general_styling = input<any>();

  @HostBinding('class') class: any;

  components: any;

  constructor() {
    super();
    const storyblokComponentService = this.storyblokComponentService;

    this.components = storyblokComponentService.getComponents();
  }

  ngOnInit() {
    this.class = this.storyblokStylingService.getClassList(this.general_styling());
  }
}
